<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
    <div class="container">
        <!-- Cabeçalho -->

        <!-- KITS -->
        <div class="section-kits">
            <h2 class="title">Veja como ficou o seu livro</h2>
            <p class="subtitle">Após nossa avaliação, seu livro está pronto! Diga-nos o que achou e, se necessário,
                faremos mais uma revisão.</p>
            <div class="book-info">
                <div class="book-header">
                    <div class="cover-box">
                        <img [src]="book?.bookFrontCoverFileName ? book?.bookFrontCoverFileName : 'assets/images/book-placeholder.svg'"
                            alt="Capa do livro" />
                        <img [src]="book?.bookBackCoverFileName ? book?.bookBackCoverFileName : 'assets/images/book-placeholder.svg'"
                            class="cover" alt="Capa traseira" />
                    </div>
                    <div class="book-info">
                        <h1>{{ book?.bookTitle }}</h1>
                        <p class="author">Por {{ book?.authorName }}</p>

                        <div class="action-buttons">
                            <button class="btn-add" style="background-color: #00c851; color: #fff; padding: 10px;"
                                mat-raised-button (click)="openPdf()">
                                Acessar o livro
                            </button>
                        </div>

                        <p *ngIf="!authorApprove" class="author" style="margin-top: 30px; color: gray; font-size: 13px; font-weight: 600;">Seu livro necessita de ajustes, veja o que o nosso revisor disse:</p>
                        <p *ngIf="!authorApprove" class="author" style="color: gray; font-size: 12px; font-weight: 400;">{{ book?.reasonReprove }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Ações -->
        <div class="details-actions">
            <div style="display: flex; flex-direction: column; justify-content: space-between; align-items: center;">
                <button class="back-btn" (click)="useCredits()">Solicitar revisão</button>
                <span style="font-size: 11px;">Você possui {{ remainingCredits }} créditos restantes</span>
            </div>
            <button [disabled]="!authorApprove" class="continue-btn" (click)="save()" style="max-height: 44px;">Aprovar e publicar</button>
            <span *ngIf="!authorApprove" style="font-size: 11px; color: red; margin-top: 8px;">O livro precisa de revisão antes de publicar</span>
        </div>
    </div>
</div>

<app-footer></app-footer>